import { ServerInterface } from "./ServerInterface";

class Common {
  days = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];

  firstDay = new Date();

  numOfDays = 3;
  globalScale = 0.5;

  numCourts = 7;

  topSpacingOnce = 50 * this.globalScale;
  topSpacingPerDay = 100 * this.globalScale;

  heightHour = 90 * this.globalScale;
  widthHour = 100 * this.globalScale;

  widthCourt = 150 * this.globalScale;

  scaleFactor = 1;
  firstHourOfDay = 6;
  lastHourOfDay = 23;

  courtSpacing = [0, 0, 0, this.widthHour, this.widthHour, this.widthHour, this.widthHour * 2];

  totalWidth = (this.widthHour * 4 + this.widthCourt * 7) / this.globalScale;

  heightOfOneDay = (this.lastHourOfDay - this.firstHourOfDay) * this.heightHour + 300 * this.globalScale;

  totalWidthUnscaled = this.totalWidth;
  totalHeightUnscaled = this.heightOfOneDay * this.numOfDays;

  fontMatch = 50 * this.globalScale + "px Arial";
  fontMatchHome = 60 * this.globalScale + "px Arial";
  fontTraining = 30 * this.globalScale + "px Arial";
  fontHour = 40 * this.globalScale + "px Arial";
  fontDate = 60 * this.globalScale + "px Arial";

  getCourtStartTime(): Array<number> {
    // const dNewTimes = new Date(2021, 6 - 1, 28);

    // if (d instanceof Date) {
    //   console.log("d is date");
    // } else {
    //   d = new Date(d);
    // }

    // if (d.getTime() < dNewTimes.getTime())
    //   return (this.courtStartTime = [30, 30, 45, 45, 0, 0, 15]);
    // else return (this.courtStartTime =

    return [30, 30, 30, 0, 0, 0, 0];
  }


  anzeigeTafelMode = false;
  kreuzbergMode = false;
  clubhausMode = false;
  anzeigeTafelHeight = 0;
  openingDate = new Date(2025, 1, 1);


  PlatzbelegungPage2Src = "https://tc-kreuzberg.de/display";

  get userMemberId(): string {
    const u = this.user;
    if (u) {
      return u.memberId || "-1";
    } else {
      return "";
    }
  }

  get user(): { memberId: string; firstName: string; lastName: string } | undefined {
    return JSON.parse(this.getUserFromLocalStorage());
  }

  myNextBookingInfo: any | undefined = undefined;
  currentBookingIsMoving = false;

  memberlist = new Array<string>();

  maxSpecialIndex = 10;

  async loadMemberList() {
    if (this.memberlist.length == 0) {
      this.memberlist = await ServerInterface.loadMemberList();

      if (this.clubhausMode) {
        this.memberlist.push("0001;Training");
        this.memberlist.push("0002;Training Jugend");
        this.memberlist.push("0003;Training Mannschaft");
        this.memberlist.push("0004;Training Privat");
        this.memberlist.push("0005;Veranstaltung");
        this.memberlist.push("0006;Wettkampf");
        this.memberlist.push("0007;Medenspiel");
        this.memberlist.push("0008;Pokal");
        this.memberlist.push("0009;GESPERRT");
      }

      this.memberlist.push("9999;GAST");
    }
  }

  myConfirm(s: string, okCallback: () => void) {
    (window as any).bootbox.confirm({
      title: "Achtung",
      message: s,
      buttons: {
        confirm: {
          label: "Ja",
          className: "btn-success",
        },
      },
      callback: (result: any) => {
        if (result) {
          if (okCallback) {
            okCallback();
          }
        }
      },
    });
  }

  myAlert(s: string, title: string, onOk?: () => void) {
    var ss = s.split("\n");
    s = ss.join("<br/>");

    (window as any).bootbox.confirm({
      title: title,
      message: s,
      buttons: {
        confirm: {
          label: "Ok",
          className: "btn-success",
        },
      },
      callback: (result: any) => {
        if (onOk) {
          onOk();
        }
      },
    });
  }

  async checkKreuzbergMode() {
    this.kreuzbergMode = await ServerInterface.checkKreuzbergMode();
  }

  constructor() {
    //
    // check for query parameters in URL
    //

    this.checkKreuzbergMode();

    this.anzeigeTafelMode = window.location.href.toLocaleLowerCase().indexOf("display") >= 0;

    this.kreuzbergMode = window.location.search.indexOf("kreuzbergMode") >= 0;
    this.clubhausMode = window.location.search.toLocaleLowerCase().indexOf("clubhausmode") >= 0;

    const urlParams = new URLSearchParams(window.location.search);
    const ah = urlParams.get("ah");
    if (ah) {
      this.anzeigeTafelHeight = parseInt(ah);
    }

    const d = new Date();
    this.firstDay = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    this.loadMemberList();
  }

  getUserFromLocalStorage(): string {
    try {
      const user = localStorage.getItem("user");
      return user || "{}";
    } catch (ex) { }
    return "{}";
  }
}

export function isLeapYear(d: Date) {
  var year = d.getFullYear();
  if ((year & 3) != 0) return false;
  return year % 100 != 0 || year % 400 == 0;
}

// Get Day of Year
export function getDOY(d: Date) {
  var dayCount = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
  var mn = d.getMonth();
  var dn = d.getDate();
  var dayOfYear = dayCount[mn] + dn;
  if (mn > 1 && isLeapYear(d)) dayOfYear++;
  return dayOfYear;
}

export function addDays(d: Date, days: number): Date {
  var date = new Date(d);
  date.setDate(date.getDate() + days);
  return date;
}

export function addHours(d: Date, hours: number): Date {
  var date = new Date(d);
  date.setHours(date.getHours() + hours);
  return date;
}

export const _common = new Common();
